import { Navigate } from 'react-router'

import { getAuthenticatedDestination, useAuth } from '@/features/auth'

import { ROUTES } from './routes'

export function AuthenticatedRootRedirect() {
  const { user } = useAuth()

  return (
    <Navigate
      to={getAuthenticatedDestination(user?.role ?? null, undefined, ROUTES.DASHBOARD)}
      replace
    />
  )
}
